import axios from 'axios'
import qs from 'qs'

if (process.env.NODE_ENV === 'production') {
  axios.defaults.withCredentials = true;
}
const service = axios.create({
  baseURL: process.env.BASE_URL_WEBAPI
})
service.interceptors.request.use(
  config => {
    if (config.method === 'post') {
      config.data = qs.stringify(config.data)
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => response.data,
  error => {
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/require.js